/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingSourceDetailsForHadolint {
    getFixupPrototypeFunction() { return SecurityFindingSourceDetailsForHadolint.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingSourceDetailsForHadolint>): SecurityFindingSourceDetailsForHadolint {
        let obj = Object.assign(new SecurityFindingSourceDetailsForHadolint(), model);
        SecurityFindingSourceDetailsForHadolint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingSourceDetailsForHadolint>): SecurityFindingSourceDetailsForHadolint {
        if (!model) return null;
        return SecurityFindingSourceDetailsForHadolint.newInstance(<SecurityFindingSourceDetailsForHadolint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingSourceDetailsForHadolint) {
        if (!obj) return;

        models.SecurityFindingSourceDetailsForHadolint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingSourceDetailsForHadolint): boolean {
        Object.setPrototypeOf(obj, SecurityFindingSourceDetailsForHadolint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.line === undefined) {
            this.line = 0;
        }
        if (this.column === undefined) {
            this.column = 0;
        }
    }

    /**
     * File path of the Dockerfile that was analyzed by Hadolint
     */
    file: string;

    /**
     * Line number in the Dockerfile where the security issue was detected
     */
    line: number;

    /**
     * Column position within the line where the security issue begins
     */
    column: number;

    /**
     * Severity level of the Dockerfile security issue as classified by Hadolint
     */
    level: models.ContainerFindingsHadolintFindingLevel;

    /**
     * Unique rule identifier code for the specific Hadolint security check that was violated
     */
    code: string;

    /**
     * Detailed explanation of the security issue and recommended remediation steps
     */
    message: string;

}
